const focusInputMixin = {
  props: {
    focusInput: {
      default: true,
      type: Boolean
    }
  },
  watch: {
    focusInput: {
      immediate: true,
      handler (val) {
        if (this.$refs.input) {
          this.$nextTick(val ? this.$refs.input.focus : this.$refs.input.blur)
        }
      }
    }
  }
}

export default focusInputMixin



// WEBPACK FOOTER //
// ./src/utils/mixins/focusInputMixin.js